import { apiRequest } from './client'
import type { LiveRepointResult } from '@/types/bundle'

interface LiveRepointResponse {
  version: string
  activated_at: string
}

// POST /gui/v1/live (PRD 26) - `version` omitted means "the newest published
// bundle" (mirrors publish.ts's own version-omitted convention, PRD 24).
// Frontend PRD 11 offers no version picker, so callers always omit it today,
// but the client function itself mirrors the backend's own optional field.
export async function goLive(version?: string): Promise<LiveRepointResult> {
  const response = await apiRequest<LiveRepointResponse>('/gui/v1/live', {
    method: 'POST',
    body: JSON.stringify(version ? { version } : {}),
  })
  return {
    version: response.version,
    activatedAt: response.activated_at,
  }
}
